import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { MasterDataService } from '../../Services/MasterDataService';
import { BaseComponent } from '../../Library/BaseComponent';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SaveShiftResponse } from '../../Models/RequestModels'
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'AddNotes',
    templateUrl: './AddNotes.html',
})

export class AddNotes extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    ModalRef: NgbModalRef;
    RequestModel: SaveShiftResponse;
    DisableModalOpenEvent: boolean = false;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
    }
    ngOnInit(): void {
    }

    Open(Model: SaveShiftResponse): void {
        if (this.DisableModalOpenEvent) return;
        this.RequestModel = Model;
        let list = Model.MultiLingualShiftNameAndNotes.filter(item => item.LanguageCode == this.masterService.LoggedInUserData.LanguageCode);
        if (list.length > 0) {
            this.RequestModel.Notes = list[0].Notes;
        }
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            size: 'lg'
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        this.DisableModalOpenEvent = true;
        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }

    SubmitNotes(): void {
        this.ModalRef.close();
    }
}
